<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-lg="4" vs-sm="4" vs-xs="12">
          <vs-button icon="keyboard_backspace" @click="goBack">Back</vs-button>
        </vs-col>
        <vs-col vs-type="flex"  vs-lg="4" vs-sm="4" vs-xs="12">
          <h3>Opportunities</h3>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="4" vs-sm="4" vs-xs="12">
          <vs-button size="small" type="flat" @click="saveViewPopup">Save View</vs-button>

<span class="mt-3 mr-5 ml-5">Select:</span>

  <v-select style="width:50%" v-model="selected_view_for_sd" label="name" :options="sd_view_options"
    name="sd_view" />
        </vs-col>
      </vs-row>

      <DataGrid :context="'ClientOpportunities'" @goToViewClientOpportunities="goToViewClientOpportunities" ref="ClientOpportunities"
        :columnDefs="columnDefs" :rowData="records" :dataSource="dataSource" :rowSelection="'single'">
      </DataGrid>



      <vs-popup title="Opportunity" fullscreen :active.sync="showSDOpportunitiesPopUp">
        <vs-row>

          <vs-row>
            <div
              class="vx-col w-full p-2"
              v-for="field in opportunity_field_options"
              
            >
  
  
  
  
              <div
                class="vx-row p-5"
                v-if="field.field_type == 'opportunity_field'"
              >
                <div class="vx-col sm:w-1/5 w-full">
                  <h6>{{ field.name }} </h6>
                </div>
  
               
  
                <div class="vx-col sm:w-2/3 w-full">
                  <div
                    class="vx-col sm:w-1/3 w-full"
                    v-if="field.type == 'text'"
                  >
                  {{ opportunity_field_datas[field.column_id].value ? opportunity_field_datas[field.column_id].value : '' }}
                  </div>
  
                  <div
                  class="vx-col sm:w-1/3 w-full"
                  v-if="field.type == 'client_contact'"


                >
                
                {{ typeof opportunity_field_datas[field.column_id].value === 'string'  ? JSON.parse(opportunity_field_datas[field.column_id].value).full_name : '' }}


                </div>

                  <div
                    class="vx-col sm:w-1/3 w-full"
                    v-if="field.type == 'number'"
                  >
                  {{ opportunity_field_datas[field.column_id].value ? opportunity_field_datas[field.column_id].value : '' }}
                  </div>
                  <div
                    class="vx-col sm:w-1/3 w-full"
                    v-if="field.type == 'textarea'"
                  >
                  <div v-html="$sanitizeHtml(opportunity_field_datas[field.column_id].value)"></div>
                                  </div>
                  <div
                    class="vx-col sm:w-1/3 w-full"
                    v-if="field.type == 'date'"
                  >
                  {{ opportunity_field_datas[field.column_id].value ? opportunity_field_datas[field.column_id].value : '' }}
                  </div>

                   <div
                    class="vx-col sm:w-1/3 w-full"
                    v-if="field.type == 'datetime'"
                  >
                  {{ opportunity_field_datas[field.column_id].value ? opportunity_field_datas[field.column_id].value : '' }}
                  </div>
  
                  <div
                    class="vx-col sm:w-1/3 w-full"
                    v-if="field.type == 'checkbox'"
                  >
                  {{ opportunity_field_datas[field.column_id].value ? opportunity_field_datas[field.column_id].value : '' }}
                  </div>
  
                  <div
                    class="vx-col sm:w-1/3 w-full"
                    v-if="field.type == 'dropdown'"
                  >
                  {{ opportunity_field_datas[field.column_id].value ? opportunity_field_datas[field.column_id].value : '' }}
                  </div>
  
                  <div
                    class="vx-col sm:w-1/3 w-full"
                    v-if="field.type == 'choose_one'"
                  >
                  {{ opportunity_field_datas[field.column_id].value ? opportunity_field_datas[field.column_id].value : '' }}
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-row w-full p-5">
              <div class="vx-col sm:w-1/5 w-full"></div>
              
            </div>
          </vs-row>


       
        </vs-row>
      </vs-popup>
      <vs-popup title="Save View" :active.sync="showHideSaveViewPopUp">
        <vs-row>
          <vs-col vs-type="flex" vs-w="12">
            <div class="vx-row w-full">
              <div class="vx-col sm:w-1/4 w-full">
                <h6>Name:</h6>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <vs-input class="w-full" v-model="save_view_name" name="name" />
                <span class="text-danger text-sm">{{ please_choose_save_view_name }}</span>

              </div>
            </div>
          </vs-col>

          <vs-col vs-type="flex" vs-w="12">
            <div class="vx-row w-full mt-5">
              <div class="vx-col sm:w-1/4 w-full">
                <h6>Description:</h6>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <vs-textarea class="w-full" name="save_view_description" v-model="save_view_description" />

                <vs-button class="mt-5" @click.prevent="submitSaveViewAction">Submit</vs-button>
              </div>
            </div>
          </vs-col>

        </vs-row>
      </vs-popup>


    </vx-card>
  </div>
</template>

<script>


var OppOwnerValueFormatter = function(params) {




if(params.value){


  params.value = JSON.parse(params.value)


    if (params.value.hasOwnProperty('full_name')){
    return params.value.full_name

  }





}
};

import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";
export default {
  data: () => ({
    selected_view_for_sd: null,
    sd_view_options: [],
    showHideSaveViewPopUp: false,
    please_choose_save_view_name: null,
    save_view_name: null,
    save_view_description: null,
    // checkedValues:['Ipad' , 'Laptop' ],
    configDateTimePicker: {
      enableTime: false,
      dateFormat: "Y-m-d"
    },
    showSDOpportunitiesPopUp: false,
    closeshowSDOpportunitiesPopUp: false,
    opportunity_field_options: [],
    opportunity_field_datas: [],
    abilities: null,
    columnDefs: [
    ],
    dataSource: {},
    records: []
  }),
  components: {
    "v-select": vSelect,
    moduleCampaignManagement,
    DataGrid,
    flatPickr,

  },
  watch: {
    selected_view_for_sd(val) {
      const opportunities_saved_state = JSON.parse(val.opportunities_view);
      this.$refs.ClientOpportunities.gridApi.applyColumnState({ state: opportunities_saved_state, applyOrder: true });

      const opportunities_filter_saved_state = JSON.parse(val.opportunities_filter);
      this.$refs.ClientOpportunities.gridApi.setFilterModel(opportunities_filter_saved_state)
    },
  },
  methods: {

    submitSaveViewAction() {
      let self = this



  


          let data = {}
      data.name = self.save_view_name;
      data.description = self.save_view_description;
      data.campaign_id = self.$route.params.campaignId;
      data.opportunities_view = this.$refs.ClientOpportunities.gridApi.getColumnState()
      data.opportunities_filter = this.$refs.ClientOpportunities.gridApi.getFilterModel();
      let save_view_user_id = []
      save_view_user_id.push(self.user_id)
      data.save_view_user_id = save_view_user_id
      data.is_default_view = false
      if (self.save_view_name != null) {
        self.$store
          .dispatch("campaignsManagement/saveOpportunitiesSavedView", data)
          .then(res => {
            if (res) {
              if (res.data.status == "success") {

                location.reload()
            
              }
              else{

self.$vs.notify({
color: "danger",
title: "Opportunites View",
text: res.data.message
});
}
            }
          })
          .catch(err => {
            console.log(err);
          });
      }

     
     


    },



    saveViewPopup() {
      this.showHideSaveViewPopUp = true
      // console.log("Account COLUMNSTATE" , this.$refs.SDQCAccount.gridApi.getColumnState())

      // console.log("Contact COLUMNSTATE" , this.$refs.SDQCContact.gridApi.getColumnState())


    },
    getOpportunitiesSavedViewLists() {
      let self = this
      let data = {}
      data.campaign_id = this.$route.params.campaignId;
      data.user_id = self.user_id;
      self.$store
        .dispatch("campaignsManagement/getClientOpportunitiesSavedViewLists", data)
        .then(res => {

          self.sd_view_options = JSON.parse(res.data);

        })
        .catch(err => {
          console.error(err);
        });
    },
    updateOpportunity() {
      let self = this;
      this.$store
        .dispatch("campaignsManagement/updateSDCreatedOpportunity", self.opportunity_field_datas)
        .then(res => {
          if (res.data.status == "success") {
            this.$vs.notify({
              color: "success",
              title: "Opportunity",
              text: res.data.message
            });
            this.$router.go(0)
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    getSelectedOpportunityFieldsWithDetails(db_value) {
      let self = this;
      let data = {}
      data.campaign_id = this.$route.params.campaignId;
      self.opportunitiesCheckedFields = {}
      self.$store
        .dispatch(
          "campaignsManagement/getSelectedOpportunityFieldsWithDetails",
          data
        )
        .then(res => {

          if (res.data) {
            let result = JSON.parse(res.data)
            self.opportunity_field_options = result[0]['options']
            self.opportunity_field_datas = result[0]['data']
            let new_opportunity_field_values = {}
            self.opportunity_field_options.forEach(function (ele) {
              Object.entries(self.opportunity_field_datas).forEach(
                ([key, value]) => {
                  if (key == ele.column_id) {
                    let json_value = null

                    try {
                      json_value = JSON.parse(value)
                    } catch (e) {
                      json_value = value
                    }

                    if (json_value != null) {
                      if (json_value.length == 1) {
                        json_value = json_value[0]
                      }

                      new_opportunity_field_values[key] = {
                        value: json_value,
                        type: ele.type,
                        options: ele.values,
                        model: key
                      }
                    } else {
                      new_opportunity_field_values[key] = {
                        value: json_value,
                        type: ele.type,
                        options: ele.values,
                        model: key
                      }
                    }
                  }
                }
              )
            })

            self.opportunity_field_datas = new_opportunity_field_values

            for (const property in self.opportunity_field_datas) {


              for (const db_value_property in db_value) {
                if (db_value_property == property) {
                  self.opportunity_field_datas[property].value = db_value[db_value_property]
                }

              }


              if (self.opportunity_field_datas[property].type == 'checkbox') {


                if (self.opportunity_field_datas[property].value != null ) {

                  if (self.opportunity_field_datas[property].value.startsWith('[[')) {

                    self.opportunity_field_datas[property].value = JSON.parse(self.opportunity_field_datas[property].value)[0]

                  }


               






                  

                }else{
                  self.opportunitiesCheckedFields[property] = []
                }
              }
            }





            self.opportunity_field_datas['campaign_id'] = db_value.campaign_id
            self.opportunity_field_datas['sd_opportunity_id'] = db_value.sd_opportunity_id
            self.opportunity_field_datas['id'] = db_value.id
            self.opportunity_field_datas['account_id'] = db_value.account_id
            self.opportunity_field_datas['contact_id'] = db_value.contact_id
            self.opportunity_field_datas['sales_developer_id'] = db_value.sales_developer_id

          }


        })
        .catch(err => {
          console.log(err)
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getSDOpportunitiesColumns() {
      let self = this
      this.$store
        .dispatch(
          "campaignsManagement/getSDOpportunitiesColumns",
          self.$route.params.campaignId
        )
        .then(response => {

          let result = JSON.parse(response.data);


          console.log("Opp Columns", result)


          result.forEach(function (ele) {
              ele.headerName = ele.name
              ele.field = ele.column_id

              if (ele.type == "textarea") {
                ele.cellRenderer =  function(params) {
                            return params.value ? params.value : '';
                        }
              }

                if (ele.type == "date" || ele.type == "datetime") {
                  ele.filter = "agDateColumnFilter";
                } else if (ele.type == "client_contact") {
                  ele.valueFormatter = OppOwnerValueFormatter
                  ele.filter = "agTextColumnFilter";
                } else if (ele.type == "number") {
                  ele.filter = "agNumberColumnFilter";
                } else {
                  ele.filter = "agTextColumnFilter";
                }



              ele.flex = 1
              ele.filterParams = {
                buttons: ['apply', 'reset'],
                maxNumConditions: 4
              }
            })

            this.columnDefs = result;


          let account_name = {
            headerName: 'account',
            flex: 1,
            field: 'company_name',
            filter: "agTextColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            }
          };

          let contact_name = {
            headerName: 'contact',
            flex: 1,
            field: 'contact_full_name',
            filter: "agTextColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            }
          };

 
          this.columnDefs.push(account_name);

          this.columnDefs.push(contact_name);


          let actions = {
            headerName: "Actions",
            sortable: false,
        field: "transactions",
        cellRenderer: 'CellRendererActions',
        suppressHeaderMenuButton: true,
        pinned: true,
        width: 50
          };

 
          this.columnDefs.push(actions);






         







        })
        .catch(err => {
          console.log(err);

          if (err.response.status === 401) {
            self.$router.replace("/login");
          }
        });
    },
    goToViewClientOpportunities(value) {
      console.log(value)
      var self = this;
      self.getSelectedOpportunityFieldsWithDetails(value)
      // self.opportunity_field_datas = value



      self.showSDOpportunitiesPopUp = true;
      // this.showPopulateDataPopUp = true;
      // alert(value)
    },
    getDataSource() {
      var self = this;
      this.dataSource = {
        getRows(params) {
          params.request.sales_developer_id = self.user_id;
          params.request.selected_campaign_id = self.$route.params.campaignId
          self.$store
            .dispatch(
              "campaignsManagement/getClientOpportunities",
              params.request
            )
            .then(function (response) {
              let response_data = response.rows;



              if (response_data.length != 0) {
                self.$refs.ClientOpportunities.gridApi.hideOverlay();
                params.success({ rowData: response.rows , rowCount: response.lastRow })
              } else {
                self.$refs.ClientOpportunities.gridApi.showNoRowsOverlay();
                return params.success({ rowData: [] })
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    goBack: function () {
      this.$router.go(-1);
    }
  },
  beforeMount() {
    // this.getDataSource();
  },
  mounted() {
    this.getDataSource();
    this.getSDOpportunitiesColumns();
    this.getOpportunitiesSavedViewLists();

  },
  created() {

    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    this.user_role = userInfo["userRole"];


    // if (this.user_role != 'Client' && this.user_role != 'Client Administrator') {
    //   this.$router.replace("/unauthorized")
    // }

    if (this.user_role == 'Sales Developer'){
      this.authorized = false
      this.$router.replace("/unauthorized")
    }

    var self = this;
    defineAbilitiesFor().then(function (data) {
      self.abilities = data;
    });
    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
  padding: 15px 15px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  width: 325px !important;
}

.searchbox {
  margin-left: 5px;
  width: 600px;
}

.filter {
  width: 300px;
}

.pointer {
  cursor: pointer;
}

.item.expanded {
  background-color: white !important;
  color: black !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  background: none !important;
  box-shadow: none !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  color: #626262 !important;
  -webkit-box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
  box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
}

.pointer {
  cursor: pointer;
}

.address_th {
  padding: 30px;
}

.address_td {
  padding: 30px;
  font-weight: 500;
}
</style>

<style lang="stylus">
.con-expand-Tags
  .con-btns-Tags
    display flex
    padding 10px
    padding-bottom 0px
    align-items center
    justify-content space-between
    .con-Tagsx
      display flex
      align-items center
      justify-content flex-start
  .list-icon
    i
      font-size .9rem !important
</style>
